import HistoryItem from '@/components/index/HistoryItem.vue';
export default {
  components: {
    HistoryItem
  },
  props: {
    //模块数据
    list: [Array],
    dataPart: {
      type: [String],
      default: ''
    }
  },
  data() {
    return {};
  },
  methods: {}
};